import { forwardRef } from 'react'

const Button = forwardRef(({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  disabled = false,
  onClick,
  type = 'button',
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-2xl transition-all duration-300 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed tracking-tight'
  
  const variants = {
    primary: 'bg-accent text-white hover:bg-accent-light shadow-lg shadow-accent/25 hover:shadow-xl hover:shadow-accent/30 active:scale-[0.98]',
    secondary: 'bg-white dark:bg-gray-800 text-accent border-2 border-accent hover:bg-accent hover:text-white shadow-md hover:shadow-lg active:scale-[0.98]',
    outline: 'bg-transparent text-gray-900 dark:text-white border-2 border-gray-300 dark:border-gray-600 hover:border-accent hover:text-accent',
    ghost: 'bg-transparent text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800',
  }
  
  const sizes = {
    sm: 'px-5 py-3 text-sm min-h-[44px]',
    md: 'px-6 py-4 text-base min-h-[52px]',
    lg: 'px-8 py-4 text-lg min-h-[56px]',
    xl: 'px-10 py-5 text-xl min-h-[60px]',
  }
  
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
})

Button.displayName = 'Button'

export default Button
